import { useContext, useEffect, useState } from "react";
import MercadoPagoLogo from "../../../assets/images/generico/MercadoPagoLogo";
import MercadoPagoLogoDesktop from "../../../assets/images/generico/MercadoPagoLogoDesktop";
import PagarSeguro from "../../../assets/images/generico/PagarSeguro";
import {
  wsGetMercadoPagoLaboratorioQr,
  wsGetMercadoPagoReferencia,
  wsGetMercadoPagoTurnosQr,
} from "../../../context/Actions/mercadoPago/mercadoPago";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { PortalContext } from "../../../context/Provider";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import "./AbonaTurno.css";
import { GlobalContext } from "../../../../global/context/Provider";
import { detectarIOS } from "../../../../global/utils/detectarIOS";
import { Capacitor } from "@capacitor/core";

const AbonaTurno = ({
  idturno,
  idProtocolo,
  monto,
  fecha,
  hora,
  centro,
  especialidad,
  dismiss,
}) => {
  const { mercadoPagoDispatch, mercadoPagoState, selectDropDownState } =
    useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch, toasterState } = useContext(GlobalContext);

  const [disabled, setDisabled] = useState(false);

  const isIOS = detectarIOS();
  const [deviceType, setDeviceType] = useState(Capacitor.platform);
  const [loading, setLoading] = useState(false);

  const [initial, setInitial] = useState(false);

  let paciente =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido;

  const abonar = () => {
    // Función para hacer que
    // se pague un turno
    const funLoading = (isCorrect) => {
      if (isCorrect) {
        setLoading(true);
      } else {
        showToaster(
          {
            texto: mercadoPagoState.mercadoPago.error
              ? mercadoPagoState.mercadoPago.error.detail
              : "Hubo un error.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        setLoading(false);
      }
    };

    if (idProtocolo > 0) {
      wsGetMercadoPagoLaboratorioQr(
        idProtocolo,
        funLoading
      )(mercadoPagoDispatch);
      setInitial(true);
    } else {
      wsGetMercadoPagoTurnosQr(idturno, funLoading)(mercadoPagoDispatch);
      setInitial(true);
    }
  };

  let loop = () => {
    let count = 0;
    setLoading(true);
    let interval = setInterval(() => {
      let stopLoop = (isCorrect, data) => {
        data = JSON.parse(data.content);
        let condition =
          data.id !== 0 &&
          data.external_reference !== null &&
          data.status !== null &&
          data.initPoint !== null;
        if (isCorrect && condition) {
          // Debo llevar al próximo paso
          clearInterval(interval);
          setLoading(false);
          dismiss("mercadoPago", true, "Pago realizado correctamente");
        } else if (!isCorrect) {
          // Ocurrio un problema al obtener la informacion
          dismiss(
            "mercadoPago",
            false,
            "Ocurrió un problema al realizar el pago"
          );
          clearInterval(interval);
        }
      };
      wsGetMercadoPagoReferencia(
        mercadoPagoState.mercadoPago.data.referenciaExterna,
        stopLoop
      )(mercadoPagoDispatch);
      // Cantidad de veces que realiza el loop
      count++;
      if (count === 12) {
        clearInterval(interval);
        dismiss(
          "mercadoPago",
          false,
          "Finalizó el tiempo de espera, se volverá a cargar la información de los próximos turnos"
        );
      }
    }, 5000);

    return interval;
  };

  useEffect(() => {
    let idinterval;
    if (initial && mercadoPagoState.mercadoPago.data) {
      idinterval = loop();
      const idWebservice = JSON.parse(
        mercadoPagoState.mercadoPago.data.idWebservice
      );
      if (isIOS) {
        if (deviceType !== "web") {
          window.location.href = idWebservice.initPoint;
        } else {
          window.open(idWebservice.initPoint, "_blank");
        }
      } else {
        window.open(idWebservice.initPoint, "_blank");
      }
    }

    return () => {
      if (idinterval) {
        clearInterval(idinterval);
      }
    };
  }, [mercadoPagoState.mercadoPago.data]);

  return (
    <div className="ptur-abonaTurno-container">
      <div className="ptur-abonaTurno-header bgcG-latex30">
        <span className="rb18b c-white">Abonar turno reservado</span>
        <div className="ptur-cruz" onClick={dismiss}>
          <div className="ptur-cruzParte1"></div>
          <div className="ptur-cruzParte2"></div>
        </div>
      </div>
      <div className="ptur-abonaTurno-body">
        <div className="ptur-abonaTurno-columna1">
          <div className="ptur-abonaTurno-detallePago">
            <span className="rb18m">{especialidad}</span>
            <span className="rb18m">
              {fecha && (
                <>
                  {getDiaStrTurno(fecha)}{" "}
                  <span className="rb18l">{getDiaStrTurno(fecha, true)}</span>
                </>
              )}
            </span>
            <span className="rb18m">
              Horario: <span className="rb18l">{hora}</span>{" "}
            </span>
            <span className="rb18m">
              Centro: <span className="rb18l">{centro}</span>{" "}
            </span>
          </div>
          <div className="ptur-card-abonaTurno-body-greyLine"></div>
          <div className="ptur-abonaTurno-totalAbono">
            <span className="rb18l">
              Total a abonar: <span className="rb18m">{`$` + monto}</span>{" "}
            </span>
          </div>
          <span className="ptur-card-abonaTurno-descripcion c-latex10 rb12l">
            Abone ahora para garantizar su reserva y agilizar el ingreso al
            centro de salud. También puedes abonar el turno el mismo día en el
            centro.
          </span>
        </div>
        <div className="ptur-abonaTurno-columna2">
          <div className="ptur-abonaTurno-mercadoPagoLogo">
            <MercadoPagoLogo width={"210"} />
          </div>
          <div className="ptur-abonaTurno-mercadoPagoLogoDesktop">
            <MercadoPagoLogoDesktop />
          </div>
          <div className="ptur-abonaTurno-botones">
            <button
              className={
                disabled
                  ? `ptur-abonaTurno-btn  bgc-grey65`
                  : ` ptur-abonaTurno-btn bgc-latex10`
              }
              onClick={abonar}
              disabled={disabled}
            >
              <PagarSeguro />
              <span className="rb16m c-white">Pagar con Mercado Pago</span>
            </button>
            <button
              className="ptur-abonaTurno-btn-outline bgc-white"
              onClick={dismiss}
            >
              <span className="rb16m c-latex30">Abonar luego</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbonaTurno;
